export default [
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/Privacy.vue"),
    meta: {}
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("../views/Terms.vue"),
    meta: {}
  }
]